import styled from "@emotion/styled"
import Button from "@material-ui/core/Button"

export const ErrorButton = styled(Button)`
  background-color: ${({ theme }) => theme.palette.error.main};
  color: ${({ theme }) => theme.palette.common.white};
  &:hover {
    background-color: ${({ theme }) => theme.palette.error[600]};
  }
  &:active {
    background-color: ${({ theme }) => theme.palette.error.dark};
  }
`
